<template>
    <div class="expanded-tilat">
        <div class="expanded-header">
            <div class="header-info">
                <h4>{{ row.tilanimike?.nimi }}</h4>
                <p v-if="row.toiminta" class="tasmennys-text">{{ row.toiminta }}</p>
            </div>
            <el-tag v-if="getDuplicateCount(row) > 0" type="warning" size="small">
                {{ getDuplicateCount(row) }} duplikaattia
            </el-tag>
        </div>

        <!-- Side by Side Layout for Tilat and Liitteet -->
        <el-row :gutter="16">
            <!-- Tilat Section -->
            <el-col :span="12">
                <ComHuonekorttiTilatTable :tilat="row.tilat ?? []" />
            </el-col>

            <!-- Liitteet Section -->
            <el-col :span="12">
                <ComHuonekorttiLiitteetTable
                    :liitteet="liitteet"
                    :loading="liitteetLoading"
                    @download-liite="(id) => $emit('downloadLiite', id)" />
            </el-col>
        </el-row>
    </div>
</template>

<script setup lang="ts">
import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { LiiteResponse } from "@/api/models/liite-response"
import ComHuonekorttiTilatTable from "./ComHuonekorttiTilatTable.vue"
import ComHuonekorttiLiitteetTable from "./ComHuonekorttiLiitteetTable.vue"
import { useHuonekorttiTableWithDuplicates } from "./huonekorttiTable"
import { hankePage } from "@/views/hanke"

const { id: hankeId } = hankePage()
const { getDuplicateCount } = useHuonekorttiTableWithDuplicates(hankeId)

defineProps<{
    row: HuonekorttiResponse
    liitteet: LiiteResponse[] | undefined
    liitteetLoading: boolean
}>()

defineEmits<{
    downloadLiite: [id: number]
}>()
</script>

<style scoped>
.expanded-tilat {
    padding: 16px;
    background-color: #fafafa;
    border-radius: 8px;
    margin: 8px 0;
}

.expanded-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;
}

.header-info h4 {
    margin: 0;
    color: #303133;
    font-size: 16px;
}

.tasmennys-text {
    margin: 4px 0 0 0;
    color: #606266;
    font-size: 14px;
    font-style: italic;
}
</style>